import React from 'react'
import styled, { css } from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'

import type { IconProps } from '../icons'

export type SolidButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: React.FC<IconProps>
}

export const SolidButton: React.FC<SolidButtonProps> = ({
  children,
  icon,
  onClick,
  ...props
}: SolidButtonProps) => {
  const Icon = icon
  const haptics = useHapticFeedback()

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (onClick) {
      haptics.impactOccurred('light')
      onClick(e)
    }
  }

  return (
    <Root $iconOnly={!children} onClick={handleClick} type="button" {...props}>
      <Icon size={20} />
      {children ? <Text>{children}</Text> : undefined}
    </Root>
  )
}

const Root = styled.button<{ $iconOnly: boolean }>`
  border: none;
  outline: none;
  cursor: pointer;

  display: inline-grid;
  justify-items: center;
  align-items: center;
  padding: 11px;
  gap: 2px;
  border-radius: 10px;

  position: relative;
  overflow: hidden;
  background: var(--background-1);
  color: var(--text-9);

  transition: all 0.2s ease;

  &:hover {
    background: var(--background-4);
    color: var(--text-11);

    & > svg {
      color: var(--text-12);
    }
  }

  ${({ $iconOnly }) => {
    if ($iconOnly) {
      return css`
        width: 48px;
      `
    }
    return css`
      width: auto;
    `
  }}

  & > svg {
    position: relative;
    color: var(--text-11);
  }
`

const Text = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 500;
`
